export default "/images/8c6a99050d2e1f36b46bc6f4d4f0e934.avif";